/**
 * React Query hooks for the investor System Map screen. The shareholder map
 * changes rarely (re-vendored on demand), so a long staleTime is fine. Hook
 * names mirror the admin-console originals so the ported graph components work
 * unchanged.
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchBrainTree,
  fetchBrainPage,
  fetchBrainGraph
} from '@/api/systemMap';

export function useBrainTree() {
  return useQuery({
    queryKey: ['shareholderMapTree'],
    queryFn: fetchBrainTree,
    staleTime: 5 * 60_000
  });
}

export function useBrainPage(path: string | null) {
  return useQuery({
    queryKey: ['shareholderMapPage', path],
    queryFn: () => fetchBrainPage(path as string),
    enabled: !!path,
    staleTime: 5 * 60_000
  });
}

export function useBrainGraph() {
  return useQuery({
    queryKey: ['shareholderMapGraph'],
    queryFn: fetchBrainGraph,
    staleTime: 5 * 60_000
  });
}
